var _excluded = ["unmountReact", "modalTitle"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Modal, Button, SageTokens } from '@kajabi/sage-react';
import './style.scss';

var noop = function noop() {};

var withModal = function withModal(WrappedComponent) {
  function Wrapper(_ref) {
    var unmountReact = _ref.unmountReact,
        modalTitle = _ref.modalTitle,
        rest = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/React.createElement(Modal, {
      active: true,
      large: true,
      className: "sage-scoped",
      onExit: noop
    }, /*#__PURE__*/React.createElement(Modal.Header, {
      title: modalTitle,
      aside: /*#__PURE__*/React.createElement(Button, {
        color: Button.COLORS.SECONDARY,
        iconPosition: Button.ICON_POSITIONS.RIGHT,
        icon: SageTokens.ICONS.REMOVE,
        subtle: true,
        onClick: unmountReact
      }, "Close")
    }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({}, rest, {
      closeModal: unmountReact
    }))));
  }

  Wrapper.defaultProps = {
    modalTitle: 'Upload file'
  };
  return Wrapper;
};

export default withModal;